import React, { useEffect } from 'react';
import DialogModal from '../../utils/DialogModal';


const PoorNetworkWarningDialog = ({ open }: { open: boolean }) => {

    return (
        <DialogModal open={open} onClose={() => { }} iconClass={"exclam"} title="Poor Network Connection">
            <>
                <p>
                    Try to find a better signal to continue using Studio
                </p>
            </>
        </DialogModal>
    )
}

export default PoorNetworkWarningDialog;
